<template>
  <sea-page class="mt-3" title="Dati utenza" header="Dati utenza" back>
    <sea-page-content toolbar hideRapidSearch>
      <template v-slot:toolbar>
        <table-toolbar-button
          icon="mdi-content-save"
          label="Salva"
          @click="save"
          :disabled="$v.datiUtente.$invalid"
        ></table-toolbar-button>
      </template>
      <v-card max-width="600" flat>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="10" offset="1">
                <v-text-field
                  label="Username"
                  placeholder="Username"
                  type="text"
                  v-model="datiUtente.login"
                  required
                  :error-messages="errors('login')"
                  @input="$v.datiUtente.login.$touch()"
                  @blur="$v.datiUtente.login.$touch()"
                ></v-text-field>
                <v-text-field
                  label="Email"
                  placeholder="Email"
                  type="email"
                  v-model="datiUtente.email"
                  minlength="5"
                  maxlength="254"
                  required
                  :error-messages="errors('email')"
                  @input="$v.datiUtente.email.$touch()"
                  @blur="$v.datiUtente.email.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import mixin from "@/mixin";

export default {
  mixins: [mixin, validationMixin],
  validations: {
    datiUtente: {
      login: {
        required,
      },
      email: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(254),
        email,
      },
    },
  },
  mounted() {
    this.fetchUserData().then((res) => {
      this.datiUtente.login = res.login;
      this.datiUtente.email = res.email;
    });
  },
  data() {
    return {
      datiUtente: {
        login: "",
        email: "",
      },
    };
  },
  methods: {
    save() {
      this.$v.$touch();
      if (!this.$v.datiUtente.$invalid) {
        this.updateUserData({
          login: this.datiUtente.login,
          email: this.datiUtente.email,
        });
      }
    },
    errors(fieldName) {
      const vals = [];
      if (!this.$v.datiUtente[fieldName].$dirty) return vals;
      if (fieldName === "login") {
        !this.$v.datiUtente.login.required && vals.push(this.locales.required);
      } else if (fieldName === "email") {
        !this.$v.datiUtente.email.required && vals.push(this.locales.required);
        !this.$v.datiUtente.email.minLength &&
          vals.push(this.locales.minLength(5));
        !this.$v.datiUtente.email.maxLength &&
          vals.push(this.locales.maxLength(254));
        !this.$v.datiUtente.email.email && vals.push(this.locales.email);
      }
      return vals;
    },
    ...mapActions({
      fetchUserData: "account/fetchUserData",
      updateUserData: "account/updateUserData",
    }),
  },
};
</script>
